import React, { Component } from "react";
import { connect } from "react-redux";

import "../assets/css/style.css"

class OverviewScreen extends Component {
    switchKind (kind) {
        this.props.switchKind(kind)
        this.props.switchScreen(2)
    }

    render () {
        return (
            <div className="overviewScreen">
                <div className="overviewContainer">
                    <div className="kindRow">
                        <div
                            className={"kind critical"}
                            onClick={() => this.switchKind(0)}
                        >
                            <p>Überfällige Rechnungen</p>
                            <div className="routineScreenVerticalLine"></div>
                            <p>{this.props.cases[0].length}</p>
                        </div>
                        <div
                            className={"kind new"}
                            onClick={() => this.switchKind(1)}
                        >
                            <p style={{ paddingLeft: 2, paddingRight: 2 }}>Fällig</p>
                            <div className="routineScreenVerticalLine"></div>
                            <p>{this.props.cases[3].length}</p>
                        </div>
                        <div
                            className={"kind new"}
                            onClick={() => this.switchKind(3)}
                        >
                            <p style={{ paddingLeft: 2, paddingRight: 2 }}>Unbearbeitet</p>
                            <div className="routineScreenVerticalLine"></div>
                            <p>{this.props.cases[3].length}</p>
                        </div>
                    </div>
                    <div className="kindRow">
                        <div
                            className={"kind new"}
                            onClick={() => this.switchKind(2)}
                        >
                            <p style={{ paddingLeft: 2, paddingRight: 2 }}>
                            Neue Rechnungen
                            </p>
                            <div className="routineScreenVerticalLine"></div>
                            <p>{this.props.cases[2].length}</p>
                        </div>
                        <div
                            className={"kind new"}
                            onClick={() => this.switchKind(4)}
                        >
                            <p style={{ paddingLeft: 2, paddingRight: 2 }}>Wiedervorlage</p>
                            <div className="routineScreenVerticalLine"></div>
                            <p>{this.props.cases[4].length}</p>
                        </div>
                        <div
                            className={"kind new"}
                            onClick={() => "/"}
                        >
                            <p style={{ paddingLeft: 2, paddingRight: 2 }}>Suche</p>
                            <div className="routineScreenVerticalLine"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
      cases: state.cases
    };
  };

export default connect(mapStateToProps)(OverviewScreen)



// WEBPACK FOOTER //
// ./src/screens/OverviewScreen.js